export default __webpack_public_path__ + "static/media/pnCTA.d58c861a.png";